// @ts-nocheck
import { Dictionary } from "@insite/client-framework/Common/Types";
import { GetProductByIdApiV2Parameter, ProductExpandTokens } from "@insite/client-framework/Services/ProductServiceV2";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export const loadProductRequiredExpands: ProductExpandTokens = [
    "attributes",
    "badges",
    "content",
    "detail",
    "documents",
    "images",
    "specifications",
    "variantTraits",
    "properties",
];

export const loadProductRequiredParameters: Partial<GetProductByIdApiV2Parameter> = {
    expand: loadProductRequiredExpands,
    includeAttributes: ["includeOnProduct", "notFromCategory"],
};

export const productIsMissingMandatoryExpands = (product: ProductModel) => {
    return (
        !product.attributeTypes ||
        !product.badges ||
        !product.content ||
        !product.detail ||
        !product.documents ||
        !product.images ||
        !product.specifications ||
        !product.variantTraits ||
        !product.properties
    );
};

export type LoadVariantProductParameter = { id: ProductModel["id"]; properties: ProductModel["properties"] };
export const loadVariantIds: Dictionary<string> = {};

export const setLoadVariantId = (key: string, loadVariantId: string) => {
    loadVariantIds[key] = loadVariantId;
};

export const getLoadVariantIdForProductId = (productId: string) => {
    return loadVariantIds[productId] || productId;
};

export const setLoadVariantIdForProduct = (product: LoadVariantProductParameter | undefined, loadVariantId: string) => {
    if (!product) {
        return undefined;
    }

    const {
        id,
        properties: { parentNumber },
    } = product;

    setLoadVariantId(id, loadVariantId);

    if (parentNumber) {
        setLoadVariantId(parentNumber, loadVariantId);
    }
};

export const getLoadVariantIdForProduct = (product: LoadVariantProductParameter | undefined) => {
    let loadVariantId: string | undefined;

    if (product) {
        const {
            id,
            properties: { parentNumber },
        } = product;

        const resultById = loadVariantIds[id];
        const resultByParentNumber = parentNumber ? loadVariantIds[parentNumber] : undefined;
        loadVariantId = resultById || resultByParentNumber || product.id;

        setLoadVariantIdForProduct(product, loadVariantId);
    }

    return loadVariantId;
};

export const getLoadVariantIdForProducts = (products: Array<LoadVariantProductParameter>) => {
    let loadVariantId: string | undefined;

    products.some(({ id, properties: { parentNumber } }) => {
        const resultById = loadVariantIds[id];
        const resultByParentNumber = parentNumber ? loadVariantIds[parentNumber] : undefined;
        loadVariantId = resultById || resultByParentNumber;

        return Boolean(loadVariantId);
    });

    if (!loadVariantId) {
        loadVariantId = products[0].id;
    }

    products.forEach(x => setLoadVariantIdForProduct(x, loadVariantId as string));

    return loadVariantId;
};
